import Resource from "./resource.model";

export default class Service {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.finished = false;
        this.duration = 30;
        this.color = null;
        this.resources = [];
        this.finishedDate = null;

        if (data) {
            Object.assign(this, data);

            if (this.resources) {
                this.resources = this.resources.map((resourceData)=> {
                    return new Resource(resourceData);
                });
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/service.model.js